import { Component, Input } from '@angular/core';
import { ZoningCode } from 'src/app/modules/instance/models';
import { InstanceService, TaskService, ZoningCodeService } from 'src/app/modules/instance/services';
import { Task } from 'src/app/shared';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { filter, switchMap } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ZcIndexingProcessSettingsDialogComponent } from '../../../dialogs/zc-indexing-process-settings-dialog/zc-indexing-process-settings-dialog.component';

@Component({
    standalone: false,
    selector: 'app-zoning-code-reindex-button',
    templateUrl: './zoning-code-reindex-button.component.html',
    styleUrls: ['./zoning-code-reindex-button.component.scss']
})
export class ZoningCodeReindexButtonComponent {
    constructor(
        protected readonly zoningCodeService: ZoningCodeService,
        protected readonly instanceService: InstanceService,
        protected readonly dialog: MatDialog,
        protected readonly taskService: TaskService
    ) {}

    @Input()
    zoningCode: ZoningCode;

    @Input()
    task: ITaskModel;

    reindexZoningCode(event: Event, offset?: number) {
        event.stopPropagation();
        const indexingTask = this.getIndexingTask();

        if (!indexingTask) {
            this.openIndexZCPropertyRecordsTaskDialog().subscribe(indexingTasParams => {
                if (!indexingTasParams) {
                    return;
                }
                this.zoningCodeService.indexZCPropertyRecords({
                    ...indexingTasParams,
                    instance: this.instance,
                    zoningCodeId: this.zoningCode.Id,
                    zcGridicsId: this.zoningCode.GridicsId,
                    offset
                });
            });
            return;
        }

        this.openReindexZCPropertyRecordsDialog(this.zoningCode, indexingTask, offset);
    }

    getIndexingTask() {
        return this.zoningCode.Tasks.find(task => Task.isIndexing(task)) || this.task;
    }

    get instance() {
        // tslint:disable-next-line:max-line-length
        return this.task
            ? this.instanceService.getInstanceById(this.task.instanceId)
            : this.instanceService.selectedInstance;
    }

    openReindexZCPropertyRecordsDialog(_zoningCode: ZoningCode, indexingTask: ITaskModel, offset?: number) {
        const dialogConfig = new MatDialogConfig();

        const title = 'Start reindexing';

        const topContent = 'Indexing is in process.',
            bottomContent = 'Do you want to stop it and start reindexing?',
            okButtonColor = 'warn';

        dialogConfig.autoFocus = true;
        dialogConfig.data = { title, topContent, bottomContent, okButtonColor };
        this.dialog
            .open(ConfirmationDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(
                filter(isConfirm => isConfirm),
                switchMap(() => this.taskService.deleteTask(indexingTask)),
                switchMap(() => this.openIndexZCPropertyRecordsTaskDialog()),
                filter(indexingTasParams => indexingTasParams)
            )
            .subscribe(indexingTasParams => {
                this.zoningCodeService.indexZCPropertyRecords({
                    ...indexingTasParams,
                    instance: this.instance,
                    zoningCodeId: this.zoningCode.Id,
                    zcGridicsId: this.zoningCode.GridicsId,
                    offset
                });
            });
    }

    protected openIndexZCPropertyRecordsTaskDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = this.zoningCode;
        dialogConfig.maxHeight = '850px';
        dialogConfig.width = '650px';
        dialogConfig.disableClose = true;

        return this.dialog
            .open(ZcIndexingProcessSettingsDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(filter(isConfirm => isConfirm));
    }
}
